import { rgbToken, token } from '@/services/theme/css-tokens'

// Colors come from the palette's CSS tokens (see src/scss/_root-variables.scss).
// The second argument is a fallback from the old indigo-herb palette.
export default {
  presets: {
    light: {
      textPrimary: rgbToken('--c-font-rgb', '44, 49, 112'),
      backgroundPrimary: token('--c-bg-primary', '#F7F3EA'),
      backgroundSecondary: token('--c-bg-secondary', '#FFFFFF'),
      backgroundCardPrimary: token('--c-bg-card-primary', '#F7F9F9'),
      backgroundCardSecondary: token('--c-bg-card-secondary', '#ECFDE6'),
      success: token('--c-success-bg', 'rgba(237, 247, 237, 1)'),
      info: token('--c-info', '#158DE3'),
      danger: token('--c-danger-preset', '#862D46'),
      warning: token('--c-warning', '#FFD43A'),
    },
    dark: {
      backgroundCardPrimary: '#111827',
      backgroundCardSecondary: '#0f172a',
    },
  },
  currentPresetName: 'light',
  variables: {
    primary: rgbToken('--c-primary-rgb', '44, 49, 112', 1),
    // Neutral gray, not the brand color: border-color="secondary" buttons
    // are meant to have a gray outline (matches --va-secondary in CSS).
    secondary: token('--c-secondary', '#767C88'),
    success: rgbToken('--c-success-rgb', '76, 175, 80', 1),
    warning: rgbToken('--c-warning-rgb', '255, 153, 0', 1),
  },
}
